import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Stack, Grid, List, styled } from '@mui/material';

import { breadcrumbsActions } from '@store/breadcrumbs';
import ApplicationPageTemplate from '@dashboardComponents/ApplicationPageTemplate/ApplicationPageTemplate';

import Filters from './MethodMatrixFilters';
import LobCard from './MethodMatrixLobCard';

import { getLOBs, selectLOBList } from '../../store/payment-options-merchants';
import { selectFilteredLOB } from '../../store/payment-options-method-matrix';

import { viewMethodMatrix } from '../../payment-options.breadcrumbs';

const MatrixDataWrapper = styled(Stack)`
  gap: 16px;
  margin-bottom: 32px;
`;

export default function MethodMatrix() {
  const dispatch = useDispatch();

  const filteredLOB = useSelector(selectFilteredLOB);
  const lobList = useSelector(selectLOBList);

  const filteredLobList =
    filteredLOB.length === 0
      ? lobList
      : lobList.filter(({ lobId }) => filteredLOB.includes(lobId));

  useEffect(() => {
    dispatch(breadcrumbsActions.showMenu(true));
    dispatch(breadcrumbsActions.setBreadcrumbs(viewMethodMatrix));

    // API: List of LoBs
    dispatch(getLOBs());
  }, [dispatch]);

  return (
    <ApplicationPageTemplate
      title="Payment Method Matrix"
      pageReady>
      <Grid
        container
        spacing={2}>
        <Grid
          item
          xs={3}>
          <Filters />
        </Grid>
        <Grid
          item
          xs={8}>
          <MatrixDataWrapper>
            <List disablePadding>
              {filteredLobList.map((lob) => (
                <LobCard
                  key={lob.lobId}
                  lob={lob}
                />
              ))}
            </List>
          </MatrixDataWrapper>
        </Grid>
      </Grid>
    </ApplicationPageTemplate>
  );
}
